import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import { PaginatedListOfAdminExerciseAssetDto } from "@growth-machine-llc/stridist-api-client";
import { ADMIN_EXERCISES_ASSETS_KEY_QUERY_KEY } from "../ExercisesTable";
import AdminService from "../../../services/AdminService";

export function useAdminPublicDeleteExercise() {
  return useOptimisticUpdateMutation({
    queryKey: [ADMIN_EXERCISES_ASSETS_KEY_QUERY_KEY],
    mutationFn: AdminService.adminDeletePublicExercise,
    optimisticUpdater: {
      updateFn: (oldData: PaginatedListOfAdminExerciseAssetDto, id: number) => {
        return {
          ...oldData,
          items: oldData.items.filter((item) => item.id !== id),
        } as PaginatedListOfAdminExerciseAssetDto;
      },
    },
    invalidateQueryOptions: {
      enabled: true,
      refetchType: "none",
    },
    exactQueryKey: false,
  });
}
